import { render, staticRenderFns } from "./text-editor-field.vue?vue&type=template&id=255c517e"
import script from "./text-editor-field.vue?vue&type=script&lang=js"
export * from "./text-editor-field.vue?vue&type=script&lang=js"
import style0 from "./text-editor-field.vue?vue&type=style&index=0&id=255c517e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports